import React, { useEffect } from "react";
import { Outlet, Navigate, useNavigate } from "react-router-dom";
import getCookie, { AuthToken } from "../components/Common/Utils";
import Navbar from "../components/Navbar";

export const PublicRoutes = () => {
  // const isAuthenticated = () => getCookie("detection_auth");
  const navigate = useNavigate();
  // useEffect(() => {
  //   if (!AuthToken.isValid()) {
  //     navigate("/");
  //   }
  // }, []);
  if (!AuthToken.isValid()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
